/**
 * Built-in field status indicator rule sets.
 *
 * These live in code, not org meta: org meta carries only the
 * globalConfig["fieldIndicators.enabled"] flag, so every colour, glyph and label stays
 * in the frontend where it is reviewed and tested, and switching an org on is a
 * one-line config change.
 *
 * `match` lists every accepted spelling of a state. The list API returns the tag's
 * displayName while the entity-tags API returns its valueCode, and the two do not
 * normalise to the same value - see normalizeIndicatorValue in indicatorRules.js.
 */
/**
 * Indicators attached to the Inventory > All Vehicles bus number.
 *
 * Attachment lives in code, not org meta: org meta carries only the on/off flag, so
 * switching an org on never requires editing column config. Shared by the cell that
 * renders the marker and the list request that has to ask for its source fields.
 */
export const ALL_VEHICLES_INDICATORS = ["operationalStatus"];

export const INDICATOR_PRESETS = {
    operationalStatus: {
        sourceField: "tag_battery_status",
        reasonField: "tag_battery_sub_status",
        placement: "top-right",
        rules: [
            {
                match: ["non_operational", "Non-Operational"],
                icon: "status-maintenance",
                color: "#B42318",
                background: "#FEE9E7",
                tooltip: "Non-Operational",
                appendReason: true,
            },
            {
                match: ["onboarding_inprogress", "onboarding in progress"],
                icon: "status-onboarding",
                color: "#1B3FA0",
                background: "#E8EDFB",
                tooltip: "Onboarding In Progress",
            },
        ],
    },
};

export default INDICATOR_PRESETS;
